import { addresses } from '@unite-us/client-utils';
import { isEmpty, uniq } from 'lodash';
import { formatAddress } from 'src/components/ClientSummary/utils';
import { EMPTY_MEMBER_CONTACT_VALUE } from './memberContact.constants';

export function getPreferredLanguageSummary(languages = []) {
  const languageNames = uniq(
    languages
      .map((language) => language?.language_name)
      .filter(Boolean),
  );

  return languageNames.length > 0 ? languageNames.join(', ') : EMPTY_MEMBER_CONTACT_VALUE;
}

export function getMemberContactSectionData(contact = null) {
  const preferredContactMethods = contact?.contact_preference?.preferred_contact_methods || [];
  const timeslots = contact?.contact_preference?.timeslots;
  const contactNotes = contact?.contact_preference?.contact_notes;
  const address = formatAddress(addresses.findMainAddress(contact?.addresses)) || EMPTY_MEMBER_CONTACT_VALUE;
  const preferredLanguage = getPreferredLanguageSummary(contact?.preferred_languages);

  return {
    address,
    contactNotes,
    hasContactNotes: !isEmpty(contactNotes),
    hasTimeslots: !isEmpty(timeslots),
    preferredContactMethods,
    preferredLanguage,
    timeslots,
  };
}
